import { render, staticRenderFns } from "./YourDetailsPage.vue?vue&type=template&id=772852e6&scoped=true&"
import script from "./YourDetailsPage.vue?vue&type=script&lang=js&"
export * from "./YourDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./YourDetailsPage.vue?vue&type=style&index=0&id=772852e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772852e6",
  null
  
)

export default component.exports